<template>
  <div class="row justify-content-center" style="padding-bottom: 20px">
    <div class="col-lg-6 mt-2">
      <idx-card
        :title="`${this.$t('menu.settings.integrations.titleCollectShoot')}`"
      >
        <div class="row">
          <div class="col-12">
            <div class="col-12">
              <div class="col-12 mb-3">
                <p>
                  {{ $t('menu.settings.integrations.descriptionCollect') }}
                </p>
                <p>
                  {{ $t('menu.settings.integrations.descriptionModelReturn') }}
                </p>
              </div>
              <div class="url">
                <label>Webhook URL:</label>
                <input
                  type="text"
                  v-model="events.link"
                  :placeholder="`${events[0].link}`"
                  class="form-control"
                />
                <span>{{ $t('menu.settings.integrations.required') }}</span>
              </div>

              <label>Auth Token:</label>
              <div class="token" style="margin-bottom: 5px; display: flex;">
                <input
                  type="text"
                  v-model="token"
                  :placeholder="`${events[0].link}`"
                  class="form-control"
                />
                <div class="custom-copy">
                  <button
                    :title="`${$t('resend.invitesTable.labels.copy')}`"
                    class="fas fa-copy copy"
                    @click="copyToken(token)"
                  ></button>
                </div>
              </div>
              <b-button variant="outline-primary" @click="generateNewToken">Gerar novo token</b-button>

              <div class="form-group" style="margin-top: 32px;">
                <div class="col-4 dinline-collect">
                  <button @click="testIntegration" class="btn btn-primary">
                    {{ $t('menu.settings.integrations.integrationTest') }}
                  </button>
                </div>
                <div class="custom-switch col-4" style="display: inline">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enable-config"
                    v-model="checkedValueStatus"
                    :title="`${this.$t(
                      'menu.settings.integrations.titleStatus',
                    )}`"
                  />
                  <label
                    v-if="events.active"
                    class="custom-control-label"
                    for="enable-config"
                  >
                    Desabilitar integração
                  </label>
                  <label
                    v-if="!events.active"
                    class="custom-control-label"
                    for="enable-config"
                  >
                    {{ $t('menu.settings.integrations.integrationHabilit') }}
                  </label>
                </div>
              </div>
              <div class="pull-right">
                <button
                  @click="$router.push('/integrations')"
                  class="btn btn-secondary"
                  style="max-width: 300px"
                >
                  {{ $t('menu.settings.integrations.cancel') }}
                </button>
                <button
                  @click="saveUrl"
                  class="btn btn-primary"
                  style="max-width: 300px"
                >
                  {{ $t('menu.settings.integrations.save') }}
                </button>
              </div>
            </div>
            <GoBackButton />
          </div>
        </div>
      </idx-card>
    </div>
  </div>
</template>
<script>
// import axios from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';
import IdxCard from '@/components/molecules/idx-card';
import swal from 'sweetalert';
import GoBackButton from '../../../../atoms/goback-button';
import api from '../../../../../services/api';

export default {
  name: 'Integrations',

  data() {
    return {
      userAuth: null,
      publicKey: null,
      events: [
        {
          type: 'shoot',
          active: false,
          link: '',
        },
      ],
      token: '',
    };
  },

  components: {
    IdxCard,
    GoBackButton,
  },

  methods: {
    generateNewToken(){
      this.token = uuidv4();
    },

    copyToken(text){
      navigator.clipboard.writeText(text);
      this.$bvToast.toast('O Token foi copiado para a área de transferência.', {
        title: 'Token copiado',
        autoHideDelay: 3000,
        variant: 'success',
        solid: true,
      });
    },

    testIntegration() {
      if (this.events.link === '' && !this.token) {
        swal({
          title: 'Dados incorretos',
          text: 'Digite uma url',
          icon: 'warning',
          buttons: 'Ok',
        });
      } else {
        api.post(
          '/webhooks/link/collect',
          {
            link: this.events.link,
            companyId: this.$store.state.companies.company._id,
          },
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );
        swal({
          text: 'Sucesso!',
          icon: 'success',
          buttons: 'Ok',
        });
      }
    },

    async saveUrl() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
      await api.post(
        '/webhooks',
        {
          data: {
            companyId: this.userAuth.companyId,
            events: [
              {
                type: 'answer',
                active: this.events[0].active,
                link: this.events.link,
              },
            ],
          },
        },
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      await swal({
        title: 'Webhook - Coleta de resposta',
        text: 'Salva com sucesso!',
        icon: 'success',
        buttons: 'Ok',
      });
    },
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const response = await api.get(`/webhooks/${this.userAuth.companyId}`, {
      headers: { 'x-access-token': this.userAuth.token },
      params: {
        companyId: this.userAuth.companyId,
      },
    });
    this.events[0].active = response.data.events[0].active;
    this.events.link = response.data.events[0].link;
  },

  computed: {
    isActive() {
      return this.events[0].active;
    },

    checkedValueStatus: {
      get() {
        return this.events[0].active;
      },
      set(newValue) {
        this.events[0].active = newValue;
      },
    },
  },
};
</script>

<style>
.custom-copy {
  text-align: right;
  justify-content: right;
  display: flex;
  width: 50px;
}

.copy {
  color: #4ce595;
  background-color: transparent;
  border: 1px solid #4ce595;
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 5px;
}

.dinline-collect {
  display: inline;
}

.row.justify-content-center {
  background: #fff;
}

.url {
  padding-top: 20px;
  padding-bottom: 20px;
}

/* .idx-card {
  margin-top: 30px;
  margin-bottom: 30px;
} */
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/integrations-webhooks/collect-shoot/index.vue